<div class="hour-field" [ngClass]="state()" [class.is-disabled]="disabled()">
  <div class="hour-field-container">
    <ui-inline-svg class="hour-field-icon" [name]="'clock'"></ui-inline-svg>
    <input class="hour-field-input" type="time" [(ngModel)]="value" [name]="name()" [disabled]="disabled()" autocomplete="true">
  </div>
  @if (alert() && state() !== fieldState.Default) {
    <div class="hour-field-alert">
      <ui-inline-svg class="hour-field-alert-icon" [name]="icon()"></ui-inline-svg>
      <span class="hour-field-alert-text">{{ alert() }}</span>
    </div>
  }
</div>
